// Public marketing pricing mirror. Source of truth for checkout lives in
// /app/backend/billing.py (BILLING_PACKAGES["myservicehelper"]).

// Array form (used by BookDemoModal). Single plan now.
export const PUBLIC_PLANS = [
    {
        id: "myservicehelper",
        name: "MyServiceHelper",
        monthly: 695, // kr./md. ekskl. moms
        tagline: "Alt kernesystemet · 300 AI-minutter · uden binding",
    },
];

export const PUBLIC_PLAN = PUBLIC_PLANS[0];

export const PUBLIC_ADDONS = [
    { id: "extra_minutes_100", name: "100 ekstra AI-minutter", unit_price: 129, unit_label: "engangskøb", recurring: false },
    { id: "extra_minutes_500", name: "500 ekstra AI-minutter", unit_price: 549, unit_label: "engangskøb", recurring: false },
    { id: "phone_number", name: "MyServiceHelper-telefonnummer", unit_price: 199, unit_label: "md.", recurring: true },
    { id: "extra_flow", name: "Ekstra afdeling / AI-flow", unit_price: 299, unit_label: "md.", recurring: true },
];

export const formatKr = (n) => `${Math.round(Number(n) || 0).toLocaleString("da-DK")} kr.`;
